// start:ng42.barrel
export * from './view-my-account.component';
// end:ng42.barrel




// WEBPACK FOOTER //
// ./src/main/webapp/stay-mgmt/app/components/view-my-account/index.ts